import { Component, OnInit, Input } from '@angular/core';
import { CommonButton } from '../button/button.component';
import { Router, NavigationEnd } from '@angular/router';

export class NavBarLink {
    title: string;
    url: string;
    children?: NavBarLink[];
}

@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent implements OnInit {
    @Input() logoUrl = '/';
    @Input() background: 'transparent' | 'white' = 'white';
    @Input() textColor: 'black' | 'white' = 'black';
    @Input() links: NavBarLink[] = [];
    @Input() overlay = false;
    private _rightButton: CommonButton;
    @Input() set rightButton(button: CommonButton) {
        button === null
            ? (this._rightButton = null)
            : (this._rightButton = new CommonButton(button));
    }
    get rightButton() {
        return this._rightButton;
    }
    mobileNavView = 'menu';
    showPartnerSearch = true;
    constructor(private router: Router) {
        router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (
                    event.url === '/partners' ||
                    event.url === '/' ||
                    event.url.startsWith('/categories') ||
                    event.url === '/apply'
                ) {
                    this.showPartnerSearch = false;
                } else {
                    this.showPartnerSearch = true;
                }
            }
        });
    }

    ngOnInit() {}
}
